import format from 'date-fns/esm/format'
import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import * as styles from './lockupLastUpdated.module.css'

const LockupLastUpdated = ({ item }: IItemCard) => {
  const updatedAt = get(item, 'updated_at')
  if (!updatedAt) {
    return null
  }
  return (
    <div className={styles.root}>
      <span className={styles.label}>Last updated:</span>{' '}
      <span className={styles.value}> {format(updatedAt, 'd MMM YY')}</span>
    </div>
  )
}

export default LockupLastUpdated
